import type { TFunction } from 'i18next';

export function initialsOf(email: string): string {
  const local = email.split("@")[0];
  const parts = local.split(/[._-]/).filter(Boolean);
  if (parts.length >= 2) return (parts[0][0] + parts[1][0]).toUpperCase();
  return local.slice(0, 2).toUpperCase();
}

export function timeAgo(iso: string, t: TFunction): string {
  try {
    const then = new Date(iso).getTime();
    const now = Date.now();
    const diff = Math.max(0, now - then);
    const min = Math.floor(diff / 60000);
    if (min < 1) return t("login.lastSignedInAgo", { time: t("common.timeJustNow", { defaultValue: "just now" }) });
    if (min < 60) return t("login.lastSignedInAgo", { time: min + "m" });
    const hr = Math.floor(min / 60);
    if (hr < 24) return t("login.lastSignedInAgo", { time: hr + "h" });
    const days = Math.floor(hr / 24);
    if (days < 30) return t("login.lastSignedInAgo", { time: days + "d" });
    const months = Math.floor(days / 30);
    return t("login.lastSignedInAgo", { time: months + "mo" });
  } catch {
    return "";
  }
}

export function maskEmail(email: string): string {
  const [local, domain] = email.split("@");
  if (!domain) return email;
  if (local.length <= 2) return local[0] + "***@" + domain;
  return local.slice(0, 2) + "***@" + domain;
}
